import { createTheme } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

export const CustomTheme = createTheme(themeBase, {
  palette: {
    primary: {
      main: "#C0ABD3", // color 2
      dark: "#604772", // obscuro
      light: "#1E1A34", // color 1
    },
    secondary: {
      main: "#604772", // accents
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    backgroundRight: {
      main: "#C0ABD3",
      dark: "#604772",
      light: "#1E1A34",
      tab: "#E0F7FA",
    },
    phoneInput: {
      main: "#E3F2F8",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#FFFFFF",
      tabText: "#FFFFFF",
      tabBackground: "#604772",
      menuIcon: "#C0ABD3",
    },
    barProgress: {
      main: "#C0ABD3",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#E3F2F8",
      barColor: "#604772",
      iconColor: "#C0ABD3",
      markLabelColor: "#604772",
    },
    buttonSelected: {
      backgroundColor: "#C0ABD3",
      backgroundColorActive: "#604772",
      textColor: "#FFFFFF",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#1E1A34",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#1E1A34",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#1E1A34",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1E1A34",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#1E1A34",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#1E1A34",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#C0ABD3",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#C0ABD3",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#604772",
              color: "#1E1A34",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#C0ABD3",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#C0ABD3",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#C0ABD3",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#C0ABD3",
              opacity: 0.4,
              color: "#FFF",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#C0ABD3",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#C0ABD3",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#C0ABD3",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#604772",
            backgroundColor: "#FFF",
            border: "2px solid #604772",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#1E1A34",
            color: "#FFFFFF",
            backgroundColor: "#604772",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#604772",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#604772",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#C0ABD3",
            backgroundColor: "#1E1A34",
            "&.Mui-disabled": {
              backgroundColor: "#1E1A34",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#1E1A34",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#C0ABD3",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#C0ABD3",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#604772",
              color: "#1E1A34",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#FF6060",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#1E1A34", // Borde azul cuando no está enfocado
              borderRadius: "4px",
            },
            "&:hover fieldset": {
              borderColor: "#1E1A34", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1E1A34", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#1E1A34", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#1E1A34",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1E1A34",
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: "14px",
          boxShadow: "8px 4px 20px 0px rgba(82, 140, 214, 0.25)",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
          // border: "2px red solid"
          // ".aria-labelledby": {
          //   border: "2px blue solid"
          // }
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        determinate: {
          color: "#1E1A34",
        },
        indeterminate: {
          color: "#C0ABD3",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#333F48",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "arra_capital",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "Arra Capital",
    description:
      "Arra Capital es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "arracapital/portal/logos/favicon.ico",
    ogImage: "https://demo-clientes-arra-capital.lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  navbar: {
    logo: "arracapital/portal/logos/logo.png",
    logo_width: 90,
    logo_height: "auto",
  },
  lateral: {
    logo_width: 200,
    logo_height: "auto",
    logo_dark: "arracapital/portal/logos/logo.png",
    bg_light: CustomTheme.palette.primary.main,
    text_light: "#FFFFFF",
    logo_light: "arracapital/portal/logos/logo.png",
    bg_dark: CustomTheme.palette.primary.main,
    text_dark: "#FFFFFF",
    image_list: [
      "lendia/portal/lateral/imagen_1.webp",
      "lendia/portal/lateral/imagen_2.webp",
      "lendia/portal/lateral/imagen_3.webp",
      "lendia/portal/lateral/imagen_4.webp",
      "lendia/portal/lateral/imagen_5.webp",
      "lendia/portal/lateral/imagen_6.webp",
      "lendia/portal/lateral/imagen_7.webp",
      "lendia/portal/lateral/imagen_8.webp",
      "lendia/portal/lateral/imagen_9.webp",
      "lendia/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Así de fácil: solicita, compara, avanza",
      "Tu crédito, tu elección, tu crecimiento",
      "Crédito simple, procesos simples",
      "Avanza con las mejores condiciones del mercado",
      "Compara y decide: tu crédito, tus reglas",
      "Un solo lugar, todas las opciones de financiamiento",
      "Crecer nunca fue tan sencillo",
      "Descubre la mejor solución para tu PyME",
      "El poder de elegir está en tus manos",
      "Da el paso que tu empresa necesita",
    ],
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_C3of6D9mC",
      userPoolClientId: "12h0thrckrfev03a2dp0mhj1bu",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_XyIwUBIO1",
      userPoolClientId: "21ng0d0rdcte886odr84mhsad8",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
